// extracted by mini-css-extract-plugin
export default {"main":"a483cef33f _2470afaddf","xmark":"_5e07132b09","fl_img":"_1d8c282181 _094e0453de"};